import { colorScales, BLUE_GRAY } from "../constants/colors";
import Color from "./Color";

class ColorScale {
  constructor(scaleName, size, padTo = 0) {
    const defaultColorScale = colorScales[BLUE_GRAY];
    const colorScale = colorScales[scaleName] || defaultColorScale;
    this.scale = colorScale(size);
    this.size = size;

    const mainColors = new Array(size)
      .fill(0)
      .map((_, i) => this.scale(i))
      .map((x) => new Color(x))
      .map((x) => x.normalize());

    const padColors = new Array(Math.max(0, padTo - size))
      .fill(0)
      .map(() => this.scale(0))
      .map((x) => new Color(x))
      .map((x) => x.normalize());

    this.colors = mainColors.concat(padColors);
  }

  get vectors() {
    return this.colors.map((x) => x.vec);
  }

  get hexes() {
    return this.colors.map((x) => x.hex);
  }

  setOpacity(a = 1) {
    this.colors = this.colors.map((x) => x.setOpacity(a));
    return this;
  }

  brighten(val) {
    this.colors = this.colors.map((x) => x.brighten(val));
    return this;
  }

  setTheme(theme) {
    this.colors = this.colors.map((x) => x.fixLuminance(theme));
    return this;
  }
}

export default ColorScale;
